//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { ITikTokFormState } from '@universal-scheduling/models/SchedulerPostDetailsModels';

export const DEFAULT_TIKTOK_POST_DETAILS_STATE: ITikTokFormState = {
  postType: UniversalPostType.TikTokVideoAutomaticPost,
  postNow: false,
};

export const MAX_TIKTOK_CAPTION_LENGTH = 2200;
export const MAX_TIKTOK_HASHTAG_COUNT = 5;
export const TIKTOK_MIN_DIMENSION_PX = 360;
export const TIKTOK_MIN_VIDEO_DURATION_MILLIS = 3000; // 3 seconds
export const TIKTOK_MAX_VIDEO_DURATION_MILLIS = 600000; // 10 minutes

export const TikTokPostDetailsFormFieldErrorText = {
  NoMediaOrText: 'Please add a caption to this post.',
  TextTooLong: `Please enter ${MAX_TIKTOK_CAPTION_LENGTH} characters or less.`,
  TooManyHashtags: `Please include ${MAX_TIKTOK_HASHTAG_COUNT} hashtags or less.`,
} as const;
